<script lang="ts">
    export let loading = false;
</script>

{#if loading}
    <div class="global-search__loading">
        <span
            class="global-search__loading-text global-search__loading-animation"
        >
            Searching
        </span>
    </div>
{/if}

<style>
    .global-search__loading {
        @apply flex flex-row rounded-sm px-4 py-2 hover:bg-gray-100;
    }

    .global-search__loading-text {
        @apply text-sm;
    }

    .global-search__loading-animation:after {
        content: "...";
        animation: dots 1s steps(5, end) infinite;
    }

    @keyframes dots {
        0%,
        20% {
            color: rgba(0, 0, 0, 0);
            text-shadow:
                0.25em 0 0 rgba(0, 0, 0, 0),
                0.5em 0 0 rgba(0, 0, 0, 0);
        }
        40% {
            color: white;
            text-shadow:
                0.25em 0 0 rgba(0, 0, 0, 0),
                0.5em 0 0 rgba(0, 0, 0, 0);
        }
        60% {
            text-shadow:
                0.25em 0 0 white,
                0.5em 0 0 rgba(0, 0, 0, 0);
        }
        80%,
        100% {
            text-shadow:
                0.25em 0 0 white,
                0.5em 0 0 white;
        }
    }
</style>
